import { Box } from "@chakra-ui/react";
import HeroImage from "../images/stamps.png";

/**
 * The faint sketch watermark behind a page, as on the Studio pages. Put it
 * first inside a Box with position="relative" and minHeight="100vh"; panels
 * on top use a see-through background (whiteAlpha.800) so it shows through.
 */
const WatermarkBackground = () => (
  <Box position="absolute" top={0} left={0} width="100%" height="100%" zIndex={-1} pointerEvents="none">
    <Box as="img" src={HeroImage} alt="" width="100%" height="100%" objectFit="cover" opacity={0.35} filter="blur(1px)" />
  </Box>
);

export default WatermarkBackground;
